// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__CmnP+","choice":"Home_choice__k2PlG","title":"Home_title__bLgsj","items":"Home_items__Cyru6"};